import { helpers, React, ts, ui, useSelector } from '_core';

import { prepareLinearData } from './helpers';
import { Params } from './types';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  context: ts.types.basket.BasketAnalysisContext;
  title: string;
};

const Chart = ({ id, readOnly, fullScreen, loadWidgetData, portfolios, params, context, title }: ChartProps) => {
  const baskets = useSelector((state) => state.resources.baskets);

  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [alert, setAlert] = React.useState<{ type: 'error' | 'warning'; message: string } | null>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        const formattedData = prepareLinearData(response.data, context.basket_id, params.basket_ids, baskets);
        setData(formattedData);
      }
    } catch (err) {
      setAlert({
        type: 'error',
        message: helpers.parseApiError(err as ts.types.common.ApiError),
      });
    }
  };

  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  return (
    <ui.LineChart id={id} data={data} alert={alert} readOnly={readOnly} exportTitle={title} fullScreen={fullScreen} />
  );
};

export default Chart;
